import ApiService from '../../../common/ApiCalls'

/**
 * Verifies domain by making an api call to server.
 * Returns null on unsuccessful verification
 * @param userEmail - email used to login
 * @returns {Promise<null>} - domain verification
 */
export async function verifyDomain (userEmail) {
  let verifyDomainResponse = null
  try {
    verifyDomainResponse = await ApiService().verifyDomain({ email: userEmail })
  } catch (e) {
    console.log(e)
  }
  return verifyDomainResponse
}

export async function loginAuth (token, identityProviderName) {
  let authLoginResponse = null
  try {
    authLoginResponse = await ApiService().login({
      idtoken: token,
      identity: identityProviderName
    })
  } catch (e) {
    console.log(e)
  }
  window.localStorage.setItem('isGod', true)

  // if (
  //   authLoginResponse.data.group_ids.includes(
  //     '6fd5b5c4-0978-49f6-b301-85f60434c1b9'
  //   )
  // ) {

  // }
  return authLoginResponse
}
